<main class="flex flex-col justify-center content-center h-full w-full">
  <article
    class="mx-4 md:mx-0 flex flex-col justify-between self-center border rounded-md w-[150em] p-12">
    <h1 class="text-base text-center">
      No configuration found for the determined club.
    </h1>
  </article>
</main>
